{
  "language": {
    "title": "Izaberite jezik",
    "en": "Engleski",
    "nl": "Holandski",
    "sr": "Srpski",
    "fr": "Francuski",
    "de": "Nemački",
    "pt": "Portugalski"
  },
  "home": {
    "welcomeMessage": "Zdravo, šta vas danas dovodi ovde?",
    "checkIn": "Prijava",
    "independentManualCheckIn": "Bez sastanka",
    "integratedManualCheckIn": "Prijavite se ručno",
    "checkOut": "Odjava",
    "manualCheckOut": "Odjavite se ručno",
    "parcelDelivery": "Dostava paketa",
    "foodDelivery": "Dostava hrane",
    "callReception": "Pozovi recepciju",
    "overview": "Pregled",
    "unavailable": "Recepcija trenutno nije dostupna."
  },
  "check": {
    "option": {
      "checkin": {
        "title": "Izaberite opciju za prijavu",
        "manual": "Prijavite se ručno",
        "code": "Prijavite se pomoću PIN/QR koda"
      },
      "checkout": {
        "title": "Izaberite opciju za odjavu",
        "manual": "Odjavite se po imenu",
        "code": "Odjavite se pomoću PIN/QR koda"
      }
    },
    "title": "Čekamo da skenirate vaš QR kod.<br/>Nemate QR kod? Nema problema.",
    "orText": "ILI",
    "qrScanner": {
      "checkin": {
        "title": "Izaberite opciju za prijavu"
      },
      "checkout": {
        "title": "Izaberite opciju za odjavu"
      },
      "btn": "Skenirajte vaš QR kod"
    },
    "pinCode": "Unesite vaš PIN kod",
    "manually": {
      "checkin": "Nemate podatke za prijavu?"
    },
    "status": {
      "idle": {
        "title": "Vaš kod se skenira.",
        "message": "Molimo sačekajte..."
      },
      "loading": {
        "title": "Vaš kod se skenira.",
        "message": "Molimo sačekajte..."
      },
      "error": {
        "title": "Vaš kod nije važeći.",
        "message": "Pokušajte ponovo!"
      },
      "success": {
        "checkin": {
          "default": {
            "title": "Uspešno ste prijavljeni.",
            "message": "Hvala vam."
          },
          "MeetingAttendee": {
            "no-email-sms": {
              "title": "Uspešno ste prijavljeni.",
              "message": "Hvala vam."
            },
            "email-sms": {
              "title": "Uspešno ste prijavljeni.",
              "message": "Vaš kontakt je obavešten."
            },
            "call-ping": {
              "title": "Uspešno ste prijavljeni.",
              "message": "Sada će biti uspostavljena telefonska veza sa vašim kontaktom."
            }
          },
          "Employee": {
            "title": "Uspešno ste prijavljeni.",
            "message": "Hvala vam."
          },
          "Visitor": {
            "title": "Uspešno ste prijavljeni.",
            "message": "Hvala vam."
          }
        },
        "checkout": {
          "default": {
            "title": "Uspešno ste odjavljeni.<br/>",
            "message": "Vidimo se uskoro."
          },
          "MeetingAttendee": {
            "title": "Uspešno ste odjavljeni.",
            "message": "Vidimo se uskoro."
          },
          "Employee": {
            "title": "Uspešno ste odjavljeni.",
            "message": "Vidimo se uskoro."
          },
          "Visitor": {
            "title": "Uspešno ste odjavljeni.",
            "message": "Vidimo se uskoro."
          }
        }
      }
    }
  },
  "manualCheckin": {
    "title": "Molimo popunite.",
    "subtitle": "Napomena - Svako polje * je obavezno",
    "noOption": "Nema opcije",
    "btn": "Prijavite se",
    "placeholder": {
      "name": "Vaše ime *",
      "email": "Vaš e-mail *",
      "phone": "Broj mobilnog telefona",
      "contactName": "Ime vašeg kontakta *"
    },
    "error": {
      "required": "Niste popunili ovo polje",
      "name": "Nevažeće ime",
      "email": "Nevažeća e-mail adresa",
      "phone": "Nevažeći broj mobilnog telefona"
    },
    "status": {
      "loading": {
        "title": "Molimo sačekajte...",
        "message": "Vaš kontakt se obaveštava."
      },
      "success": {
        "no-email-sms": {
          "title": "Uspešno ste prijavljeni.",
          "message": "Hvala vam."
        },
        "email-sms": {
          "title": "Uspešno ste prijavljeni.",
          "message": "Vaš kontakt je obavešten."
        },
        "call-ping": {
          "title": "Uspešno ste prijavljeni.",
          "message": "Sada će biti uspostavljena telefonska veza sa vašim kontaktom."
        }
      },
      "error": {
        "title": "Došlo je do greške.",
        "message": "Pokušajte ponovo!"
      }
    }
  },
  "manualCheckout": {
    "title": "Unesite svoje ime za odjavu",
    "btn": "Odjavite se",
    "form": {
      "placeholder": {
        "name": "Vaše puno ime *"
      },
      "loading": "Učitavanje...",
      "noOptions": "Nema opcija"
    },
    "error": {
      "required": "Niste popunili ovo polje",
      "name": "Nevažeće ime"
    },
    "status": {
      "loading": {
        "title": "Skeniramo vaše podatke.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "title": "Uspešno ste odjavljeni.",
        "message": "Hvala vam i prijatan dan."
      },
      "error": {
        "title": "Došlo je do greške prilikom odjavljivanja.",
        "message": "Pokušajte ponovo!"
      }
    }
  },
  "call": {
    "title": {
      "no-email-sms": "Da li želite da obavestite svoj kontakt?",
      "email-sms": "Poslali smo e-mail/sms vašem kontaktu.<br/>Želite li dodatno da ih obavestite?"
    },
    "callBtn": "Pozovi",
    "pingBtn": "Ping",
    "smsBtn": "SMS",
    "callVideoBtn": "Video poziv",
    "noBtn": "Otkaži",
    "cancelBtn": "Otkaži poziv",
    "status": {
      "connecting": {
        "title": "Uspostavljanje poziva.<br/>Molimo sačekajte...",
        "message": ""
      },
      "ringing": {
        "title": "Pozivanje vašeg kontakta<br/>Molimo sačekajte...",
        "message": ""
      },
      "ringingReception": {
        "title": "Pozivanje recepcije.<br/>Molimo sačekajte...",
        "message": ""
      },
      "open": {
        "title": "Poziv je u toku.",
        "message": ""
      },
      "close": {
        "title": "Poziv je završen.<br/>Molimo sačekajte svog kontakta.",
        "message": ""
      },
      "closeReception": {
        "title": "Poziv je završen.",
        "message": ""
      },
      "error": {
        "title": "Poziv nije uspostavljen.<br/>Ponovo pozvati?",
        "message": ""
      }
    }
  },
  "message": {
    "status": {
      "idle": {
        "title": "Obaveštavamo kontakt.",
        "message": "Molimo sačekajte..."
      },
      "loading": {
        "title": "Obaveštavamo kontakt.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "title": "SMS je poslat. Kontakt je obavešten.",
        "message": "Hvala vam!"
      },
      "error": {
        "title": "SMS nije poslat.",
        "message": "Pokušajte ponovo!"
      }
    }
  },
  "videoCall": {
    "title": "Video poziv",
    "endCall": "KRAJ POZIVA",
    "status": {
      "idle": {
        "title": "Kreiramo video sobu.",
        "message": "Molimo vas, sačekajte..."
      },
      "loading": {
        "title": "Kreiramo video sobu.",
        "message": "Molimo vas, sačekajte..."
      },
      "success": {
        "title": "Video soba je uspešno kreirana.",
        "message": "Ulazimo u sobu..."
      },
      "error": {
        "title": "Video soba nije uspešno kreirana.",
        "message": "Molimo pokušajte ponovo!"
      }
    }
  },
  "packageDelivery": {
    "title": "Kako je lepo što dostavljate paket!",
    "subtitle": "Odaberite primaoca i obavestite ga",
    "subtitle1": "Pritisnite dugme ispod da nas obavestite da ste ovde!",
    "subtitle2": "Paket možete ostaviti na recepciji.",
    "input": {
      "label": {
        "contact": "Za koga je paket"
      },
      "error": {
        "contact": {
          "required": "Niste popunili ovo polje"
        }
      }
    },
    "button": {
      "submit": "Obavesti"
    },
    "status": {
      "loading": {
        "title": "Obaveštavamo kontakt.",
        "message": "Molimo sačekajte..."
      },
      "success": {
        "no-email-sms": {
          "title": "Hvala vam na isporuci!",
          "message": ""
        },
        "email-sms": {
          "title": "Kontakt je obavešten.",
          "message": "Hvala vam na isporuci!"
        },
        "call-ping": {
          "title": "Hvala vam na isporuci!",
          "message": "Sada će biti uspostavljena telefonska veza sa vašim kontaktom."
        }
      },
      "error": {
        "title": "Došlo je do greške.",
        "message": "Pokušajte ponovo!"
      }
    }
  },
  "foodDelivery": {
    "title": "Kako je lepo što dostavljate hranu!",
    "subtitle": "Odaberite primaoca i obavestite ga",
    "subtitle1": "Pritisnite dugme ispod da nas obavestite da ste ovde!",
    "subtitle2": "Hranu možete ostaviti na recepciji.",
    "input": {
      "label": {
        "contact": "Za koga je hrana"
      },
      "error": {
        "contact": {
          "required": "Niste popunili ovo polje"
        }
      }
    },
    "button": {
      "submit": "Obavesti"
    },
    "status": {
      "loading": {
        "title": "Obaveštavamo kontakt.",
        "message": "Molimo sačekajte!"
      },
      "success": {
        "no-email-sms": {
          "title": "Hvala vam na isporuci!",
          "message": ""
        },
        "email-sms": {
          "title": "Kontakt je obavešten.",
          "message": "Hvala vam na isporuci!"
        },
        "call-ping": {
          "title": "Hvala vam na isporuci!",
          "message": "Sada će biti uspostavljena telefonska veza sa vašim kontaktom."
        }
      },
      "error": {
        "title": "Došlo je do greške.",
        "message": "Pokušajte ponovo!"
      }
    }
  },
  "QRCodeScanner": {
    "title": "Molimo skenirajte vaš QR kod",
    "subtitle": "Poravnajte QR kod unutar crvenih uglova i držite telefon mirno."
  },
  "common": {
    "backBtn": "Nazad"
  },
  "previewPDF": {
    "page": {
      "of": "od",
      "previous": "Prethodna",
      "next": "Sledeća"
    },
    "button": {
      "cancel": "Otkaži",
      "accept": "Prihvati",
      "next": "Dalje"
    },
    "title": {
      "consent": "Potrebna je saglasnost"
    }
  },
  "offline": {
    "title": "Van mreže",
    "receptionMessage": "Recepcija je trenutno van mreže i ne može se koristiti, potrebno je proveriti internet vezu!",
    "check": "Da li ste posetilac i želite li direktno da razgovarate sa zaposlenim? Pozovite {{receptionistPhone}}"
  },
  "overview": {
    "title": "Unesite kod da otvorite pregled!",
    "noUsers": "Nema korisnika",
    "status": {
      "success": {
        "title": "Kod je važeći.",
        "message": ""
      },
      "error": {
        "title": "Kod nije važeći.",
        "message": "Pokušajte ponovo!"
      }
    },
    "checkoutStatus": {
      "loading": {
        "title": "Molimo sačekajte...",
        "message": ""
      },
      "success": {
        "title": "Uspešno odjavljen.",
        "message": ""
      },
      "error": {
        "title": "Došlo je do greške.",
        "message": "Pokušajte ponovo!"
      }
    },
    "listTitle": "Lista osoba koje su danas prijavljene, ali nisu odjavljene",
    "page": "Strana ",
    "table": {
      "head": {
        "fullName": "Ime",
        "type": "Tip",
        "checkedinAt": "Prijavljen u",
        "host": "Domaćin"
      },
      "type": {
        "Package": "Dostava paketa",
        "Food": "Dostava hrane",
        "Visitor": "Posetilac",
        "MeetingAttendee": "Pozvani posetilac",
        "Employee": "Zaposleni",
        "Guest": "Gost"
      }
    },
    "confirmModal": {
      "title": "Da li ste sigurni da želite da odjavite {{fullName}}?",
      "cancel": "Otkaži",
      "checkout": "Odjavi"
    }
  },
  "wifi": {
    "title": "Povežite se na Wi-Fi mrežu"
  }
}
